export default __webpack_public_path__ + "static/media/login_dot_logo.b8212aae.png";